import { AppLayout } from "components";
import { Routes as RoutesWrapper, Route } from "react-router-dom";
import {
  CallRecord,
  Customer,
  Dashboard,
  LeadDetail,
  Leads,
  Login,
  Project,
  Tasks,
  Source,
  Token,
  Users,
  ImportLead,
  ExportLead,
  LeadRequest,
  TokenDetail,
  Inventory,
  InventoryDetail,
  AnalysisAndReports,
  ImportInventory,
  StaffTargets,
  StaffTargetDetail,
  IndividualProperties,
  TaskDetail,
  ProjectDetail,
  MessengerApp,
  TeamPage,
  TeamDetailPage,
  UserDetail,
  WhatsappApp,
  Unauthorized,
  IndividualPropertiesImport,
  Activities,
  SalesPage,
  LeadsKanban,
} from "pages";
import {
  allLeadsPageProp,
  allPolishedLeadsPageProp,
  alltaskPageProp,
  allTokenPageProp,
  leadTypes,
  otherLeadsPageProp,
  otherPolishedLeadsPageProp,
  otherTaskPageProp,
  otherTokenPageProp,
} from "utils/constants";

export function AppRoutes() {
  return (
    <RoutesWrapper>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Dashboard />} />

        {/* Analysis and reports route commented  */}
        {/* <Route path="analysis-and-reports" element={<AnalysisAndReports />} /> */}

        <Route path="sales" element={<SalesPage />} />

        <Route path="all-activities" element={<Activities />} />

        <Route path="add-target" element={<StaffTargets />} />
        <Route path="add-target/status/:param" element={<StaffTargets />} />

        <Route
          path="add-target/complete-detail/:id"
          element={<StaffTargetDetail />}
        />

        {/* Lead routes */}
        <Route path="leads" element={<Leads routeData={allLeadsPageProp} />} />

        <Route path="leads/complete-detail/:id" element={<LeadDetail />} />

        <Route
          path="leads/:param"
          element={<Leads routeData={otherLeadsPageProp} />}
        />
        <Route
          path="leads/status/:param"
          element={<Leads routeData={otherLeadsPageProp} />}
        />
        <Route
          path="leads/priority/:param"
          element={<Leads routeData={otherLeadsPageProp} />}
        />
        {/* Lead routes */}

        {/*Polished Lead routes */}
        <Route
          path="polished-leads"
          element={<Leads routeData={allPolishedLeadsPageProp} />}
        />

        {/* <Route
          path="polished-leads/complete-detail/:id"
          element={<LeadDetail leadType={leadTypes.polishedLead} />}
        /> */}
        <Route
          path="polished-leads/:param"
          element={<Leads routeData={otherPolishedLeadsPageProp} />}
        />
        <Route
          path="polished-leads/status/:param"
          element={<Leads routeData={otherPolishedLeadsPageProp} />}
        />
        <Route
          path="polished-leads/priority/:param"
          element={<Leads routeData={otherPolishedLeadsPageProp} />}
        />
        {/*Polished Lead routes */}

        {/* Task routes */}

        <Route path="tasks" element={<Tasks routeData={alltaskPageProp} />} />
        <Route
          path="tasks/status/:param"
          element={<Tasks routeData={otherTaskPageProp} />}
        />
        <Route
          path="tasks/priority/:param"
          element={<Tasks routeData={otherTaskPageProp} />}
        />
        <Route path="tasks/complete-detail/:id" element={<TaskDetail />} />
        {/* Task routes */}

        {/* Customer routes */}
        <Route path="customer/:customerId" element={<Customer />} />

        {/* Customer routes */}

        {/* Token routes */}

        <Route path="token" element={<Token routeData={allTokenPageProp} />} />

        <Route path="token/complete-detail/:id" element={<TokenDetail />} />

        <Route
          path="token/status/:param"
          element={<Token routeData={otherTokenPageProp} />}
        />

        {/* Token routes */}

        {/* Inventory routes */}

        {/* <Route path="add-property" element={<AddProperty />} /> */}

        <Route path="chat-app/messenger" element={<MessengerApp />} />

        <Route path="chat-app/*" element={<WhatsappApp />} />

        {/* Project routes */}
        <Route path="project" element={<Project />} />

        <Route path="project/complete-detail/:id" element={<ProjectDetail />} />

        {/* Project routes */}

        <Route path="project-properties" element={<Inventory />} />
        <Route
          path="property/complete-detail/:id"
          element={<InventoryDetail />}
        />

        <Route
          path="project-properties/status/:param"
          element={<Inventory />}
        />

        <Route
          path="individual-properties"
          element={<IndividualProperties />}
        />

        <Route
          path="individual-properties/status/:param"
          element={<IndividualProperties />}
        />

        {/* Inventory routes */}

        {/* Call Record routes */}
        <Route path="call-record" element={<CallRecord />} />

        {/* Call Record routes */}

        {/* TeamsRoutes */}

        <Route path="teams">
          {/* Users routes */}
          <Route path="users" element={<Users />} />

          <Route path="user-detail/:userId" element={<UserDetail />} />

          {/* Users routes */}

          {/* Team Routes */}

          <Route path="team" element={<TeamPage />} />

          <Route path="team-detail/:teamId" element={<TeamDetailPage />} />

          {/* Team Routes */}
        </Route>
        {/* TeamsRoutes */}

        {/* Source routes */}
        <Route path="source" element={<Source />} />

        {/* Source routes */}

        {/* Lead request routes */}
        <Route path="lead-request" element={<LeadRequest />} />

        {/* Lead request routes */}

        {/* Import Lead routes */}
        <Route path="import/lead" element={<ImportLead />} />

        {/* Import Lead routes */}

        {/* Import Property routes */}
        <Route path="import/project-property" element={<ImportInventory />} />

        {/* Import Property routes */}

        {/* Import Individual Property routes */}
        <Route
          path="import/individual-property"
          element={<IndividualPropertiesImport />}
        />

        {/* Import Individual Property routes */}

        {/* Export Lead routes */}
        <Route path="bulk-operation/:param" element={<ExportLead />} />

        {/* Export Lead routes */}

        {/* Leads Kanban View */}

        <Route path="/leads-kanban-view" element={<LeadsKanban />} />

        {/* Leads Kanban View */}

        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route path="*" element={<h1>Not Found</h1>} />
      </Route>
    </RoutesWrapper>
  );
}
